/**
 * Max viewport width (inclusive) for compact top navigation: hamburger + drawer
 * instead of inline nav links. Slightly above BS `lg` (992) so narrow laptops/tablets
 * don’t get a two-row wrapped navbar — aligns with BS `xl` (1200).
 */
export const APP_NAV_COMPACT_BREAKPOINT_PX = 1200;
